// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2U8QR","col":"styles_col__3gP6J","fulfillmentStatus":"styles_fulfillmentStatus__3AaZN","emailCol":"styles_emailCol__3f5hR"};